import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => { const h = () => setScrolled(window.scrollY > 30); window.addEventListener('scroll', h, { passive: true }); return () => window.removeEventListener('scroll', h); }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 transition-all ${scrolled ? 'bg-[#F8E6DC]/95 backdrop-blur-md py-3 border-b border-[#A8B89A]/40' : 'py-5'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 grid grid-cols-[1fr_auto_1fr] items-center gap-6">
        <div className="hidden md:block font-mono text-[10px] tracking-[0.4em] uppercase text-[#A8B89A]">— {META.date.split(',')[1]?.trim() || META.date} —</div>
        <button onClick={() => setPage('home')} data-testid="em-logo" className="text-center"><p className="font-serif italic text-[34px] leading-none text-[#7A4A3F]">{META.brand.replace('&', '&').split(' & ')[0]} <span className="text-[#B89C5C]">&</span> {META.brand.split(' & ')[1]}</p><p className="font-mono text-[8px] tracking-[0.55em] uppercase text-[#7A4A3F]/55 mt-1">— {META.loc.split('·')[0].trim()} —</p></button>
        <nav className="hidden md:flex items-center justify-end gap-7 font-serif italic text-base">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`em-nav-${r.id}`} className={`transition-colors ${page === r.id ? 'text-[#B89C5C]' : 'text-[#7A4A3F]/65 hover:text-[#7A4A3F]'}`}>{r.label}</button>
          ))}
        </nav>
      </div>
    </header>
  );
}
